import { emailValidator } from "@/core/utils/emailValidator";
import { ICreateLeadProtocol, ICreateLeadProtocolRequest, ICreateLeadProtocolResponse } from "../../protocols/leads/ICreateLeadProtocol";
import { ILeadsRepository } from "../../repositories/ILeadsRepository";
import { IOriginsRepository } from "../../repositories/IOriginsRepository";
import { Lead } from "@/domain/entities/Lead";

export class CreateLeadUseCase implements ICreateLeadProtocol {
  constructor(
    private originsRepository: IOriginsRepository,
    private leadsRepository: ILeadsRepository
  ){}
  async execute({email, name, originId, phone}: ICreateLeadProtocolRequest): Promise<ICreateLeadProtocolResponse> {
    const emailIsValid = emailValidator(email)
    
    if(!emailIsValid){
      throw new Error('Email is not valid.')
    }

    const leadAlreadyExists = await this.leadsRepository.findByEmail(email)

    if(leadAlreadyExists){
      throw new Error('Lead already exists.') 
    }

    if(originId) {
      const origin = await this.originsRepository.findById(originId)

      if(!origin){
        throw new Error('Origin not found.')
      }
    }

    const lead = Lead.create({
      email,
      name,
      originId,
      phone,
    })

    await this.leadsRepository.create(lead)

    return {
      lead
    }

  }
}